export default "__VITE_ASSET__BgtYQZvw__"